import React from 'react';
import { useParams } from 'react-router-dom';
import { VerifiedBadge } from '../components/verification/VerifiedBadge';

export const VerifiedBadgeEmbedPage: React.FC = () => {
  const { clinicianId, size = 'medium' } = useParams<{ clinicianId: string; size?: 'small' | 'medium' | 'large' }>();

  // In production, fetch clinician data from API
  const clinicianData = {
    name: 'Dr. Sarah Johnson',
    verificationDate: '2024-01-01',
  };

  return (
    <div className="p-0 m-0">
      <VerifiedBadge
        clinicianId={clinicianId}
        name={clinicianData.name}
        verificationDate={clinicianData.verificationDate}
        size={size as 'small' | 'medium' | 'large'}
      />
    </div>
  );
};